/**
 * <SessionActivitiesCard> — the "Travail validé / à faire" block (organism, L0.1).
 *
 * Two emoji-titled groups ("TRAVAIL VALIDÉ ✅" / "TRAVAIL À FAIRE 📋"), each a list of
 * `<SessionActivityRow>`s, separated by a `<Divider>` when both are present. Renders nothing
 * when both are empty. Pure composition of DS atoms/molecules. No hex.
 */
import React from "react"

import { Card } from "../../molecules/Card"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Divider } from "../../atoms/Divider"
import { SessionActivityRow } from "../../molecules/SessionActivityRow"
import { type UILiveSessionReportActivity } from "../../../ports/primary/ui/types"

export type SessionActivitiesCardProps = {
    validated: UILiveSessionReportActivity[]
    todo: UILiveSessionReportActivity[]
    testID?: string
}

export function SessionActivitiesCard(props: SessionActivitiesCardProps) {
    const { validated, todo, testID } = props

    if (validated.length === 0 && todo.length === 0) return null

    return (
        <Card p="5" testID={testID}>
            <Stack gap="4">
                {validated.length > 0 && (
                    <Stack gap="3" align="center">
                        <Text size="text-xl" weight="bold">
                            TRAVAIL VALIDÉ ✅
                        </Text>
                        {validated.map((activity, index) => (
                            <SessionActivityRow key={index} activity={activity} />
                        ))}
                    </Stack>
                )}

                {validated.length > 0 && todo.length > 0 && <Divider />}

                {todo.length > 0 && (
                    <Stack gap="3" align="center">
                        <Text size="text-xl" weight="bold">
                            TRAVAIL À FAIRE 📋
                        </Text>
                        {todo.map((activity, index) => (
                            <SessionActivityRow key={index} activity={activity} />
                        ))}
                    </Stack>
                )}
            </Stack>
        </Card>
    )
}
